import { ModalBodyProps } from '@/shared/types/modal';
import { cn } from '@/shared/utils/cn';
import { useModalContext } from '../../context';

export const ModalBody = ({ children, withPadding = true }: ModalBodyProps) => {
  const { hideFooter, sectionPadding = 'md', scrollMode } = useModalContext();
  const sectionPaddingClass = sectionPadding === 'sm' ? 'ui-p-8' : 'ui-p-16';
  const isPaper = scrollMode === 'paper';

  return (
    <div
      data-imj-modal-body=""
      className={cn(
        withPadding && sectionPaddingClass,
        hideFooter && 'ui-rounded-b-lg',
        isPaper && 'ui-min-h-0 ui-flex-1 ui-overflow-y-auto custom-scrollbar'
      )}
    >
      {children}
    </div>
  );
};
